import React from 'react';
import { createRoot } from 'react-dom/client';
import PortalJobDetail from './App';

const elementContainer = document.querySelector<HTMLElement>('#portal-job-detail-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<PortalJobDetail />);
}
